import React, {h, Component} from 'preact';
import {PropTypes} from 'preact-compat';
import './MessageAgentSuccessModal.scss';


export default class MessageAgentSuccessModal extends Component {
    static get propTypes() {
        return {
            responseId: PropTypes.number,
            isBuyer: PropTypes.bool,
            agentName: PropTypes.string,
            agentPhotoUrl: PropTypes.string,
            agentPhone: PropTypes.string,
            clientUserId: PropTypes.string,
            clientPhone: PropTypes.string,
            onClickCallMeToAnotherNumber: PropTypes.func,
            onChangeNumber: PropTypes.func,
            ltk: PropTypes.string,
            ft: PropTypes.string,
            tracking: PropTypes.string,
            dynamicModules: PropTypes.string,
            agentId: PropTypes.string,
        };
    }

    state = {
        isLoading: false,
        isUpdatingPhone: false,
        clientPhone: this.props?.clientPhone || ''
    };
    phoneInputRef = React.createRef();

    componentDidMount() {
        if(typeof UpNestAnalytics != 'undefined' && UpNestAnalytics != null) {
            const sell_or_buy = this.props?.isBuyer ? 'buy' : 'sell';
            const track = this.props?.tracking == undefined ? 'message' : this.props.tracking;

            UpNestAnalytics.trackEvent("modalImpression", {
                pageId: "proposal",
                modalName: 'request_call',
                modalTrigger: `${sell_or_buy}:proposal:${track}${this.props?.ltk == undefined ? '' : this.props.ltk}${this.props?.ft == undefined ? '' : this.props.ft}`,
                pageType: "proposal",
                siteSection: sell_or_buy,
                rdcTrackingEnabled: "y",
                ...{dynamicModules: this.props?.dynamicModules},
                agentId: this.props?.agentId,
            });
        }
    }

    handlePhoneInput(event) {
        const phone = returnNumbersOnly(returnPhoneFormat(event.target.value));
        this.setState({clientPhone: phone});
    }

    handlePhoneChangeFormSubmit(event) {
        event.preventDefault();

        const $phoneInput = $(this.phoneInputRef.current);
        if (!$phoneInput.valid()) {
            return;
        }


        if(typeof UpNestAnalytics != 'undefined' && UpNestAnalytics != null) {
            const sell_or_buy = this.props?.isBuyer ? 'buy' : 'sell';
            const track = this.props?.tracking == undefined ? 'message' : this.props.tracking;
            UpNestAnalytics.trackEvent("click", {
                pageId: "proposal",
                linkName: 'change_phone_number',
                modalName: 'request_call',
                modalTrigger: `${sell_or_buy}:proposal:${track}${this.props?.ltk}${this.props?.ft}`,
                pageType: "proposal",
                siteSection: sell_or_buy,
                rdcTrackingEnabled: "y",
                ...{dynamicModules: this.props?.dynamicModules},
                agentId: this.props?.agentId,
            });
        }

        $.post('update-user-json', {
            userId: this.props?.clientUserId,
            phone: this.state.clientPhone
        }).then(data => {
            checkAjax(data);
            if (this.props?.onChangeNumber) {
                this.props?.onChangeNumber();
            }
        }).fail(() => {
            defaultAjaxError();
        });

        this.setState({isUpdatingPhone: false});
    }

    onClickCallMeTo() {
        this.setState({isUpdatingPhone: true});

        if (this.props?.onClickCallMeToAnotherNumber) {
            this.props?.onClickCallMeToAnotherNumber();
        }
    }

    render() {
        const {agentName, agentPhone, agentPhotoUrl} = this.props;
        const {isUpdatingPhone, isLoading, clientPhone} = this.state;

        return (
            <form className="modal nu-modal message-agent-success-modal fade" role="dialog">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                {agentPhotoUrl &&
                                    <div className="mt-3x mb-3x mb-5x-sm text-center agent-photo">
                                        <img src={agentPhotoUrl} onError={event => replaceImageOnError(event.target, 'img/profile-icon-l.jpg')}/>
                                    </div>
                                }
                                Your message was sent to {getFirstName(agentName)}!
                            </div>
                        </div>
                        <div className="modal-body">
                            {isUpdatingPhone ?
                                <form
                                    className="mt-3x mb-5x mb-7x-sm phone-change-form"
                                    onSubmit={this.handlePhoneChangeFormSubmit.bind(this)}>
                                    <div className="inputs">
                                        <input
                                            ref={this.phoneInputRef}
                                            type="tel"
                                            id="phone"
                                            name="phone"
                                            className="form-control phoneUS"
                                            value={returnPhoneFormat(clientPhone)}
                                            onInput={this.handlePhoneInput.bind(this)}/>
                                        <input
                                            type="submit"
                                            className="btn btn-blue"
                                            value="Change"
                                            disabled={!clientPhone || clientPhone.length < 10}/>
                                    </div>
                                    <label htmlFor="phone" className="error" generated="true" style="display: none"/>
                                </form>
                                :
                                <div className="message">
                                    {getFirstName(this.props.agentName)} will call you at <span className="text-semibold">{returnPhoneFormat(clientPhone)}</span> and answer your questions.
                                    <div className="mt-2x mb-3x mb-5x-sm">
                                        <a className="phone-change" onClick={this.onClickCallMeTo.bind(this)}>
                                            Call me at another number
                                        </a>
                                    </div>
                                </div>
                            }
                            <div className="pt-3x pt-5x-sm text-center call-cta">
                                <div className="mb-2x">
                                    Want to call this agent right now?
                                </div>
                                <a href={'tel:' + agentPhone} type="button" className="btn btn-blue-outline" onClick={() => {
                                            if(typeof UpNestAnalytics != 'undefined' && UpNestAnalytics != null) {
                                                const sell_or_buy = this.props?.isBuyer ? 'buy' : 'sell';
                                                const track = this.props?.tracking == undefined ? 'message' : this.props.tracking;
                                                UpNestAnalytics.trackEvent("click", {
                                                    pageId: "proposal",
                                                    linkName: 'call_agent',
                                                    modalName: 'request_call',
                                                    modalTrigger: `${sell_or_buy}:proposal:${track}${this.props?.ltk}${this.props?.ft}`,
                                                    pageType: "proposal",
                                                    siteSection: sell_or_buy,
                                                    rdcTrackingEnabled: "y",
                                                    agentId: this.props?.agentId,
                                                    pageName: `${sell_or_buy}:proposal`,
                                                    ...{dynamicModules: this.props?.dynamicModules}
                                                });
                                            }
                                }}>
                                    <i className="icon icon-phone-filled"/> {returnPhoneFormat(agentPhone)}
                                </a>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-gray-outline" data-dismiss="modal">Close</button>
                        </div>
                        {isLoading &&
                            <div className="loadingSpinner" style="display: block; margin: 0">
                                <img src={global.imageBaseUrl + 'spinner.gif'}/>
                            </div>
                        }
                    </div>
                </div>
            </form>
        );
    }
}
